import { useEffect, useState } from "react";
import { useCurrentStateAndParams } from "@uirouter/react";

import { getGrowthOverviewDomainHref } from "../utils/getGrowthOverviewDomainHref";

export const useGrowthOverviewDomainHref = (domain: string | undefined): string | null => {
    const { params } = useCurrentStateAndParams();
    const { country, webSource, duration } = params;
    const [href, setHref] = useState<string | null>(null);

    useEffect(() => {
        if (!domain) {
            setHref(null);
            return;
        }

        let cancelled = false;

        void getGrowthOverviewDomainHref(domain).then((resolvedHref) => {
            if (!cancelled) {
                setHref(resolvedHref);
            }
        });

        return () => {
            cancelled = true;
        };
    }, [domain, country, webSource, duration]);

    return href;
};
